import { FATOS_SEGURANCA } from '../dados/seguranca';
import { Secao } from './secao';
import { Reveal, RevealGrupo } from './reveal';

/**
 * Tom sóbrio, só fatos verificáveis — nenhuma certificação inventada.
 *
 * A seção já foi um inventário: oito fatos + papéis da LGPD + quatro blocos
 * citando cláusula, 3.830px no celular (24% da página inteira). O corte
 * para três fatos e UMA linha de LGPD foi decisão do dono — quem quiser o
 * contrato lê o contrato, e o link leva direto à cláusula.
 */
export function Seguranca(): JSX.Element {
  return (
    <Secao
      adiarRender
      alturaEstimada={950}
      id="seguranca"
      rotulo="Segurança e LGPD"
      titulo={
        <>
          O dado do seu cliente fica <span className="font-semibold">isolado</span> no seu
          escritório.
        </>
      }
      conduz="Sem selo para exibir — só o que o sistema de fato faz."
    >
      <RevealGrupo className="mt-12 grid gap-4 sm:grid-cols-3" passoMs={60}>
        {FATOS_SEGURANCA.map((fato) => {
          const Icone = fato.icone;
          return (
            <Reveal key={fato.titulo}>
              <div className="border-auth-borda/8 rounded-auth-card flex h-full flex-col gap-2 border p-5">
                <Icone size={20} className="text-auth-marca-hover shrink-0" aria-hidden />
                <h3 className="text-auth-texto text-base font-medium tracking-tight">
                  {fato.titulo}
                </h3>
                <p className="text-auth-texto-secundario text-sm leading-relaxed">
                  {fato.texto}
                </p>
              </div>
            </Reveal>
          );
        })}
      </RevealGrupo>

      {/* A LGPD em UMA linha — a resposta honesta à pergunta que o contador
          traz ("se der problema, quem responde?"), com o link para onde a
          promessa vale de verdade. O resto mora nos Termos. */}
      <Reveal className="mt-8">
        <p className="text-auth-texto-secundario max-w-2xl text-sm leading-relaxed">
          Na LGPD, o seu escritório é o{' '}
          <strong className="text-auth-texto">controlador</strong> e nós somos o{' '}
          <strong className="text-auth-texto">operador</strong> — como hoje, no papel e no
          Word. Está preto no branco na{' '}
          <a
            href="/termos#clausula-12"
            className="text-auth-marca-hover hover:text-auth-acento underline-offset-2 hover:underline"
          >
            cláusula 12 dos Termos de Uso
          </a>
          .
        </p>
      </Reveal>
    </Secao>
  );
}
